module.exports = __webpack_public_path__ + "img/clock-two-thirty.a619be34.svg";